import { createTheme } from '@mantine/core';

// Huisstijl: professioneel, benadert de publieke Stedin-stijl (fris groen),
// zonder de naam Stedin in de branding. Eén accentkleur, consistente radius
// en spacing — dit is de gedeelde ontwerptaal voor de hele app.
const groen = [
  '#e8f8ef',
  '#d0efdd',
  '#a2dcbb',
  '#70c996',
  '#48b878',
  '#2fae64',
  '#1fa859',  // primaire tint (shade 6)
  '#0f9349',  // hover/actief
  '#00823d',
  '#006b30',
];

const theme = createTheme({
  primaryColor: 'groen',
  primaryShade: 6,
  colors: { groen },
  defaultRadius: 'md',
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
  headings: {
    fontWeight: '600',
  },
  components: {
    Button: {
      defaultProps: { radius: 'md' },
    },
    Paper: {
      defaultProps: { shadow: 'sm', radius: 'md', withBorder: true },
    },
    Modal: {
      defaultProps: { radius: 'md', centered: true },
    },
  },
});

export default theme;
